// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/unit'

const DEFULAT_UNIT_FEEDBACK = () => {
    return {
      feedbackNo: 0,
      feedback:null,
      unitCompletedDate: '20200101'
    }
}

const state = {
  unitFeedback: DEFULAT_UNIT_FEEDBACK(),

}

const mutations = {
  setUnitFeedback (state, payload) {
      state.unitFeedback = payload
  },
  initUnitFeedback (state) {
      state.unitFeedback = DEFULAT_UNIT_FEEDBACK()
  }
}


/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 메인 > 오늘의 미션 > 유닛 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getUnitUse ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/units/{unitUseNo}/{freeYn}`, payload)
  },

  /**
   * 사용자 > 메인 > 오늘의 미션 > 유닛 상세 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getUnitDetailUse ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/unit-details`, payload)
  },  

  /**
   * 사용자 > 메인 > 오늘의 미션 > 유저 유닛 답변 저장 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars	
  async setMemberReply ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/member-unit-replies`, payload)
  },

  /**
   * 사용자 > 메인 > 오늘의 미션 > 유저 유닛 완료 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars	
  async setMemberUnitCmplt ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/member-unit-cmplts`, payload)
  },
  
  /**
   * 사용자 > 여행가방 > 마음날씨 답변 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars	
  async getUnitMindWeatherReply ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/mind-weather-replys`, payload)
  },

  /**
   * 사용자 > 여행가방 > 마음노트 답변 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars	
  async getUnitMindNoteReply ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/mind-note-replys`, payload)
  },
  /**
   * 사용자 > 메인 > 오늘의 미션 > 유닛 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getUnitFdb ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/units/fdb`, payload)
  },

  /**
   * 사용자 > 메인 > 오늘의 미션 > 수면일지 결과 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getSleppDiaryResult ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/sleep-diary-result`, payload)
  },
}

export default { state, mutations, actions }
